<div class="ui-g container" *ngIf="rouletteDetails" provide-parent-form>
    <div class="r-form-group">
        <label class="title" for="rouletteLink">{{'ROULETTE.LINK_ROULETTE'|translate}}</label>
        <div class="link-with-copy row">
            <button class="copy" pTooltip="{{'ROULETTE.COPY'|translate}}"
                [copyToClipboard]="rouletteDetails.RouletteLink"><i class="pi pi-copy"></i></button>
            <span class="link"><a   target="_blank"
                rel="noopener noreferrer" href="{{rouletteDetails.RouletteLink}}">{{rouletteDetails.RouletteLink}}</a></span>
        </div>
    </div>

    <div class="r-form-group">
        <label class="title" for="name">{{'ROULETTE.ROULETTE_NAME(NOT_SHOWN_TO_CUSTOMERS)'|translate}}</label>
        <input type="text" name="name" #name="ngModel" [(ngModel)]="rouletteDetails.Name" required maxlength="50">
        <div *ngIf="!name.valid && name.errors.required" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>
    <div class="r-form-group note-to-customers-text">
        <label class="title" for="comment">{{'ROULETTE.NOTE_TO_CUSTOMERS'|translate}}</label>
        <textarea style="width:100%" name="comment" #comment="ngModel" [(ngModel)]="rouletteDetails.Comment" rows="3"
            cols="30" maxlength="500"></textarea>
        <div *ngIf="!comment.valid">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>

<!-- <app-field-dialog [roulette]="roulette"></app-field-dialog>
<button class="command-button full full-width" type="button" (click)="fieldDialog.showDialog()" >{{'CUSTOMER_FIELDS.BUTTON_OPEN_DIALOG'|translate}}</button> -->
    <div class="r-form-group">
        <label class="title"
            for="expireDays">{{'ROULETTE.EXPIRATION_OF_A_PRIZE_FROM_THE_DATE_OF_RECEIPT'|translate}}</label>
        <p-dropdown [options]="expireDaysOptions" [appendTo]="null" inputId="expireDays" #expireDays="ngModel" name="expireDays"
            [(ngModel)]="rouletteDetails.ExpireDays">
            <ng-template pTemplate="selectedItem">
                {{rouletteDetails.ExpireDays|appendtext:'ROULETTE.DAYS'}}
            </ng-template>
            <ng-template let-item pTemplate="item">
                {{item|appendtext:'ROULETTE.DAYS'}}
            </ng-template>
        </p-dropdown>
        <div *ngIf="!expireDays.valid && expireDays.errors.required" class="error-required">
            {{'ERRORS.REQUIRED' | translate}}
        </div>
    </div>

    <div class="row r-form-group switch-container">
        <label class="title" for="available">{{'ROULETTE.ACTIVE_ROULETTE'|translate}}</label>
        <p-inputSwitch name="available" [ngModel]="isAvailable" [disabled]="true"></p-inputSwitch>
    </div>
    <div class="row r-form-group switch-container">
        <label class="title bold-text"
            for="autoRenewal">{{'ROULETTE.AUTOMATIC_RENEWAL_AT_THE_END_OF_THE_PERIOD'|translate}}</label>
        <p-inputSwitch name="autoRenewal" [(ngModel)]="rouletteDetails.AutoRenewalPackage"
            (onChange)="changeAutoRenewal($event)"></p-inputSwitch>
    </div>


    <div *ngIf="rouletteDetails.CreatedDate">
        <label class="date-label" for="createdDate">{{'ROULETTE.CREATE_DATE'|translate}}
            {{rouletteDetails.CreatedDate+'z'
            | date: 'HH:mm dd/MM/yyyy'}}</label>
    </div>

    <div *ngIf="rouletteDetails.UpdatedDate">
        <label class="date-label">{{'ROULETTE.UPDATE_DATE'|translate}} {{rouletteDetails.UpdatedDate+'z'
            | date: 'HH:mm dd/MM/yyyy' }}</label>
    </div>
</div>